import { OptionsListDrawer } from '@doltech/ui/lib/figma/Mobile/OptionsList/OptionsListDrawer';
import { useCycle } from '@doltech/ui/lib/hooks/useCycle';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { Heading } from '../../../../../student-do-test-questions/CompletionNoHintAnswer';
import { CompletionWithHintAnswerProps } from '../../../../../student-do-test-questions/CompletionWithHintAnswer';
import { useTestSubmissionStore } from '../../../../model/test-submissions.hook';
import BlankMobileEditor from '../../../MobileEditor/BlankMobileEditor';
import { QuestionBoxMobile } from '../../QuestionBoxMobile';

export const DoTestCompletionWithHintMobile = observer((props: CompletionWithHintAnswerProps) => {
  const { data, currentSection, ...rest } = props;
  const { options, onAnswerQuestion, formattedQuestionNo, userAnswers, paragraph, heading } = data;
  const [isOpen, toggleOpen] = useCycle(false, true);
  const [blankId, setBlankId] = React.useState(undefined);
  const [, setModified] = React.useState([]);
  const store = useTestSubmissionStore();

  const answerQuestion = (item) => {
    const { key, value: text } = item;
    if (store.preventUserAction()) return;
    toggleOpen();
    onAnswerQuestion({
      blankId,
      text,
      key,
    });
    setModified([]);
  };

  const onClose = () => {
    toggleOpen();
  };

  return (
    <QuestionBoxMobile>
      {heading && <Heading>{heading}</Heading>}
      <BlankMobileEditor
        {...rest}
        onRemoveBlank={onAnswerQuestion}
        userAnswers={userAnswers}
        key={paragraph.id}
        editorValue={JSON.parse(paragraph.editorValue)}
        no={formattedQuestionNo}
        blanks={paragraph.blanks as any[]}
        onBlankClick={(bId, eId) => {
          toggleOpen();
          setBlankId(bId);
        }}
      />
      <OptionsListDrawer
        title="Options List"
        selectedOpt={userAnswers.map((item) => item.userAnswerKey)}
        numberToString={numberToABC}
        visible={isOpen}
        options={options}
        onItemClick={answerQuestion}
        onClose={onClose}
      />
    </QuestionBoxMobile>
  );
});
